import {combineReducers} from 'redux';
import accountReducer from './accountReducer';
import calculationsReducer from './calculationsReducer';

export default combineReducers ({
    accountReducer,
    calculationsReducer,
})